// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Device Health state table + its depot popover: extends the Device Bucketing table styles
   (FrequencyBucketTable.module.css). */

.DeviceStateCityTable_section__EoCtQ {
    margin-top: 10px;
}

/* the wrapper scrolls on small screens */
table.DeviceStateCityTable_table__J7UO8 {
    min-width: 860px;
}

.DeviceStateCityTable_table__J7UO8 thead th {
    height: 40px !important;
}

/* =========================================
   COLUMNS
========================================= */

.DeviceStateCityTable_colLocation__f4Hn5 {
    width: 20%;
}

.DeviceStateCityTable_colCount__vbz3O {
    width: 10%;
}

.DeviceStateCityTable_colStatus__7XyMQ {
    width: 12%;
}

.DeviceStateCityTable_colInterval__S88Ce {
    width: 12%;
}

/* popover */
.DeviceStateCityTable_colVin__htXDF {
    width: 20%;
}

.DeviceStateCityTable_colReg__F-pv\\+ {
    width: 13%;
}

/* =========================================
   HEADER SWITCHES (Mains / Ignition / Emergency)
========================================= */

.DeviceStateCityTable_switchHeader__Z8bcU {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
}

.DeviceStateCityTable_headerSwitchRow__r8yPX {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.DeviceStateCityTable_headerSwitch__rty03 {
    position: relative;
    width: 28px;
    height: 15px;
    flex-shrink: 0;
    padding: 0;
    border: 0;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.45);
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.DeviceStateCityTable_headerSwitch__rty03::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #ffffff;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.25);
    transition: transform 0.2s ease;
}

.DeviceStateCityTable_headerSwitch__rty03:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
}

.DeviceStateCityTable_headerSwitchOn__Iy8nw {
    background: #022352;
}

.DeviceStateCityTable_headerSwitchOn__Iy8nw::after {
    transform: translateX(13px);
}

.DeviceStateCityTable_headerSwitchDanger__vU91P.DeviceStateCityTable_headerSwitchOn__Iy8nw {
    background: #e5384d;
}

.DeviceStateCityTable_headerSwitchState__fQH\\+S {
    min-width: 20px;
    font-size: 9px;
    font-weight: 700;
    text-align: left;
}

/* =========================================
   POPOVER TOOLBAR SWITCHES
========================================= */

.DeviceStateCityTable_switchChip__-8lt3 {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 9px;
    border-radius: 12px;
    background-color: #edf5fc;
    color: #4b71a2;
    font-size: 11px;
    font-weight: 600;
}

/* same switch as the header, recoloured for a light background */
.DeviceStateCityTable_chipSwitch__cq3AK {
    background: #cbd5e1;
}

.DeviceStateCityTable_chipSwitch__cq3AK.DeviceStateCityTable_headerSwitchOn__Iy8nw {
    background: #4b71a2;
}

.DeviceStateCityTable_chipSwitch__cq3AK.DeviceStateCityTable_headerSwitchDanger__vU91P.DeviceStateCityTable_headerSwitchOn__Iy8nw {
    background: #e5384d;
}

.DeviceStateCityTable_chipSwitch__cq3AK:focus-visible {
    outline-color: #4b71a2;
}

.DeviceStateCityTable_chipState__qRntY {
    min-width: 22px;
    color: #8a97a3;
    font-size: 10px;
    font-weight: 700;
}

.DeviceStateCityTable_chipStateOn__RkYxt {
    color: #4b71a2;
}

.DeviceStateCityTable_chipStateDanger__kjHZp {
    color: #e5384d;
}

/* =========================================
   CELLS
========================================= */

/* ON / OFF status tags */
.DeviceStateCityTable_statusTag__nZzzo {
    display: inline-block;
    min-width: 34px;
    padding: 1px 6px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
}

.DeviceStateCityTable_statusOn__1hi84 {
    background-color: #edf5fc;
    color: #4b71a2;
}

.DeviceStateCityTable_statusOff__wgE9J {
    background-color: #f1f3f5;
    color: #8a97a3;
}

.DeviceStateCityTable_statusDanger__ftUUc {
    background-color: #fdeef1;
    color: #e5384d;
}

/* standard for the selected switches, shown once in the Actual (today) header -
   highlighted like the reference sheet */
.DeviceStateCityTable_stdBadge__WjHHd {
    padding: 1px 7px;
    border-radius: 8px;
    background-color: #fff3c4;
    color: #6b5200;
    font-size: 10px;
    font-weight: 800;
    white-space: nowrap;
    animation: DeviceStateCityTable_stdFlash__9guDU 0.6s ease-out;
}

@keyframes DeviceStateCityTable_stdFlash__9guDU {
    from {
        box-shadow: 0 0 0 3px rgba(255, 214, 0, 0.75);
    }

    to {
        box-shadow: 0 0 0 0 rgba(255, 214, 0, 0);
    }
}

.DeviceStateCityTable_actualCount__gonnl {
    color: #022352;
    font-weight: 800;
}

/* interval vs standard (city, depot and vehicle rows): green up to the standard, red above it.
   \`tr td.\` beats the grey \`.depotRow td\` colour from FrequencyBucketTable.module.css */
tr td.DeviceStateCityTable_intervalGood__YnQNo {
    color: #1aa054;
}

tr td.DeviceStateCityTable_intervalBad__Ym\\+cn {
    color: #e5384d;
}

tr td.DeviceStateCityTable_intervalNone__rm7pf {
    color: #aeb8c1;
    font-weight: 400;
}

@media (prefers-reduced-motion: reduce) {
    .DeviceStateCityTable_headerSwitch__rty03,
    .DeviceStateCityTable_headerSwitch__rty03::after {
        transition: none;
    }

    .DeviceStateCityTable_stdBadge__WjHHd {
        animation: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/TCU/Latency/DeviceHealthCard/DeviceStateCityTable.module.css"],"names":[],"mappings":"AAAA;uCACuC;;AAEvC;IACI,gBAAgB;AACpB;;AAEA,yCAAyC;AACzC;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;2CAE2C;;AAE3C;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA,YAAY;AACZ;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;;2CAE2C;;AAE3C;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;IAC5C,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;2CAE2C;;AAE3C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,iEAAiE;AACjE;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;2CAE2C;;AAE3C,yBAAyB;AACzB;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;yCACyC;AACzC;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,6DAAiC;AACrC;;AAEA;IACI;QACI,6CAA6C;IACjD;;IAEA;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;uFACuF;AACvF;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;;QAEI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Device Health state table + its depot popover: extends the Device Bucketing table styles\n   (FrequencyBucketTable.module.css). */\n\n.section {\n    margin-top: 10px;\n}\n\n/* the wrapper scrolls on small screens */\ntable.table {\n    min-width: 860px;\n}\n\n.table thead th {\n    height: 40px !important;\n}\n\n/* =========================================\n   COLUMNS\n========================================= */\n\n.colLocation {\n    width: 20%;\n}\n\n.colCount {\n    width: 10%;\n}\n\n.colStatus {\n    width: 12%;\n}\n\n.colInterval {\n    width: 12%;\n}\n\n/* popover */\n.colVin {\n    width: 20%;\n}\n\n.colReg {\n    width: 13%;\n}\n\n/* =========================================\n   HEADER SWITCHES (Mains / Ignition / Emergency)\n========================================= */\n\n.switchHeader {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 3px;\n}\n\n.headerSwitchRow {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.headerSwitch {\n    position: relative;\n    width: 28px;\n    height: 15px;\n    flex-shrink: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 8px;\n    background: rgba(255, 255, 255, 0.45);\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.headerSwitch::after {\n    content: '';\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    width: 11px;\n    height: 11px;\n    border-radius: 50%;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.25);\n    transition: transform 0.2s ease;\n}\n\n.headerSwitch:focus-visible {\n    outline: 2px solid #ffffff;\n    outline-offset: 2px;\n}\n\n.headerSwitchOn {\n    background: #022352;\n}\n\n.headerSwitchOn::after {\n    transform: translateX(13px);\n}\n\n.headerSwitchDanger.headerSwitchOn {\n    background: #e5384d;\n}\n\n.headerSwitchState {\n    min-width: 20px;\n    font-size: 9px;\n    font-weight: 700;\n    text-align: left;\n}\n\n/* =========================================\n   POPOVER TOOLBAR SWITCHES\n========================================= */\n\n.switchChip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 3px 9px;\n    border-radius: 12px;\n    background-color: #edf5fc;\n    color: #4b71a2;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n/* same switch as the header, recoloured for a light background */\n.chipSwitch {\n    background: #cbd5e1;\n}\n\n.chipSwitch.headerSwitchOn {\n    background: #4b71a2;\n}\n\n.chipSwitch.headerSwitchDanger.headerSwitchOn {\n    background: #e5384d;\n}\n\n.chipSwitch:focus-visible {\n    outline-color: #4b71a2;\n}\n\n.chipState {\n    min-width: 22px;\n    color: #8a97a3;\n    font-size: 10px;\n    font-weight: 700;\n}\n\n.chipStateOn {\n    color: #4b71a2;\n}\n\n.chipStateDanger {\n    color: #e5384d;\n}\n\n/* =========================================\n   CELLS\n========================================= */\n\n/* ON / OFF status tags */\n.statusTag {\n    display: inline-block;\n    min-width: 34px;\n    padding: 1px 6px;\n    border-radius: 10px;\n    font-size: 10px;\n    font-weight: 700;\n}\n\n.statusOn {\n    background-color: #edf5fc;\n    color: #4b71a2;\n}\n\n.statusOff {\n    background-color: #f1f3f5;\n    color: #8a97a3;\n}\n\n.statusDanger {\n    background-color: #fdeef1;\n    color: #e5384d;\n}\n\n/* standard for the selected switches, shown once in the Actual (today) header -\n   highlighted like the reference sheet */\n.stdBadge {\n    padding: 1px 7px;\n    border-radius: 8px;\n    background-color: #fff3c4;\n    color: #6b5200;\n    font-size: 10px;\n    font-weight: 800;\n    white-space: nowrap;\n    animation: stdFlash 0.6s ease-out;\n}\n\n@keyframes stdFlash {\n    from {\n        box-shadow: 0 0 0 3px rgba(255, 214, 0, 0.75);\n    }\n\n    to {\n        box-shadow: 0 0 0 0 rgba(255, 214, 0, 0);\n    }\n}\n\n.actualCount {\n    color: #022352;\n    font-weight: 800;\n}\n\n/* interval vs standard (city, depot and vehicle rows): green up to the standard, red above it.\n   `tr td.` beats the grey `.depotRow td` colour from FrequencyBucketTable.module.css */\ntr td.intervalGood {\n    color: #1aa054;\n}\n\ntr td.intervalBad {\n    color: #e5384d;\n}\n\ntr td.intervalNone {\n    color: #aeb8c1;\n    font-weight: 400;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .headerSwitch,\n    .headerSwitch::after {\n        transition: none;\n    }\n\n    .stdBadge {\n        animation: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `DeviceStateCityTable_section__EoCtQ`,
	"table": `DeviceStateCityTable_table__J7UO8`,
	"colLocation": `DeviceStateCityTable_colLocation__f4Hn5`,
	"colCount": `DeviceStateCityTable_colCount__vbz3O`,
	"colStatus": `DeviceStateCityTable_colStatus__7XyMQ`,
	"colInterval": `DeviceStateCityTable_colInterval__S88Ce`,
	"colVin": `DeviceStateCityTable_colVin__htXDF`,
	"colReg": `DeviceStateCityTable_colReg__F-pv+`,
	"switchHeader": `DeviceStateCityTable_switchHeader__Z8bcU`,
	"headerSwitchRow": `DeviceStateCityTable_headerSwitchRow__r8yPX`,
	"headerSwitch": `DeviceStateCityTable_headerSwitch__rty03`,
	"headerSwitchOn": `DeviceStateCityTable_headerSwitchOn__Iy8nw`,
	"headerSwitchDanger": `DeviceStateCityTable_headerSwitchDanger__vU91P`,
	"headerSwitchState": `DeviceStateCityTable_headerSwitchState__fQH+S`,
	"switchChip": `DeviceStateCityTable_switchChip__-8lt3`,
	"chipSwitch": `DeviceStateCityTable_chipSwitch__cq3AK`,
	"chipState": `DeviceStateCityTable_chipState__qRntY`,
	"chipStateOn": `DeviceStateCityTable_chipStateOn__RkYxt`,
	"chipStateDanger": `DeviceStateCityTable_chipStateDanger__kjHZp`,
	"statusTag": `DeviceStateCityTable_statusTag__nZzzo`,
	"statusOn": `DeviceStateCityTable_statusOn__1hi84`,
	"statusOff": `DeviceStateCityTable_statusOff__wgE9J`,
	"statusDanger": `DeviceStateCityTable_statusDanger__ftUUc`,
	"stdBadge": `DeviceStateCityTable_stdBadge__WjHHd`,
	"stdFlash": `DeviceStateCityTable_stdFlash__9guDU`,
	"actualCount": `DeviceStateCityTable_actualCount__gonnl`,
	"intervalGood": `DeviceStateCityTable_intervalGood__YnQNo`,
	"intervalBad": `DeviceStateCityTable_intervalBad__Ym+cn`,
	"intervalNone": `DeviceStateCityTable_intervalNone__rm7pf`
};
export default ___CSS_LOADER_EXPORT___;
